
// Mobile Menu Collapse
const mobileMenuTrigger = document.querySelector('.site-header .menu-trigger');
const mobileMenu = document.querySelector('.site-header .primary-menu');
if ( mobileMenuTrigger ) {
  mobileMenuTrigger.addEventListener('click', function (){
    mobileMenu.classList.toggle('shown');
    mobileMenuTrigger.classList.toggle('is-active');
    setTimeout(() => {
      const body = document.querySelector('body');
      if ( window.innerWidth < 1024 ) {
        body.classList.toggle('overflow-y-hidden');
        body.classList.remove('faded');
      } else {
        body.classList.remove('overflow-y-hidden');
        body.classList.toggle('faded');
      }
    }, 250);
  });
}

/* Dynamic Background Color */
const dynamicBgColor = document.querySelectorAll('.bg-dynamic-color');
if ( dynamicBgColor.length != 0 ) {
  dynamicBgColor.forEach( block => {
    const windowHeight = window.innerHeight;
    window.addEventListener('scroll', function (){
      const currentBlockScrollPositionTop = block.getBoundingClientRect().top,
            currentBlockDynamicColor = block.dataset.dynamicBgColor,
            currentBlockDynamicBgEl = block.querySelector('.bg-dynamic');
      if ( currentBlockScrollPositionTop < windowHeight * 0.4 ) {
        currentBlockDynamicBgEl.classList.add('bg-'+currentBlockDynamicColor, 'border-transparent');
      } else {
        currentBlockDynamicBgEl.classList.remove('bg-'+currentBlockDynamicColor, 'border-transparent');
      }
    });
  });
}

/* Accordion */
const accordions = document.querySelectorAll('.accordion');
if ( accordions.length ) {
  accordions.forEach(accordion => {
    const accordionTitles = accordion.querySelectorAll('.accordion-title');
    accordionTitles.forEach(title => {
      title.classList.add('test');
//				title.dataset.position = title.offsetTop;
      title.addEventListener('click', function (event){
        event.stopImmediatePropagation();
        console.log('click');
        if ( !title.classList.contains('active') ) {
          accordionTitles.forEach(title => {
            title.parentElement.querySelector('.accordion-panel').classList.remove('expanded');
            title.classList.remove('active');
          });
          title.parentElement.querySelector('.accordion-panel').classList.add('expanded');
          title.classList.add('active');
//						window.scrollTo(0, accordion.offsetTop);
        } else {
          title.parentElement.querySelector('.accordion-panel').classList.remove('expanded');
          title.classList.remove('active');
        }
      });
    });
  });
}
